import Chip from '@mui/material/Chip';

const ActiveFilterChip: React.FC<{ label: string; onDelete: () => void; chipKey: string }> = ({
	label,
	onDelete,
	chipKey,
}) => (
	<Chip data-testid={`filter-chip-${chipKey}`}
		key={chipKey}
		label={label}
		onDelete={onDelete}
		color="primary"
		variant="filled"
		style={{ marginRight: 4, marginBottom: 4, fontWeight: 500, letterSpacing: 0.2 }}
	/>
);

export default ActiveFilterChip;